<template>
	<div class="page d-flex">
		<MenuComponent />
		<AppsViewComponent	 />
	</div>
</template>

<script>

import MenuComponent from '@/components/user/layout/MenuComponent.vue';
import AppsViewComponent from '@/components/user/viewComponent/apps/AppsViewComponent.vue';

export default{
	name: 'AppsLibraryView',
  components:{
    MenuComponent,
    AppsViewComponent,
  }
}
</script>

